import React from "react";
import {
  Card,
  CardHeader,
  CardTitle,
  CardAction,
  CardContent,
} from "@/components/ui/card";
import { ShieldCheck } from "lucide-react";

interface ContentCardProps {
  title: string;
  count: number;
  description: string;
  linkText: string;
  onLinkClick?: () => void;
  icon?: React.ReactNode;
}

const ContentCard: React.FC<ContentCardProps> = ({
  title,
  count,
  description,
  linkText,
  onLinkClick,
  icon = <ShieldCheck className="h-8 w-8 text-green-600" />,
}) => {
  return (
    <div className="flex flex-col w-1/3/4 justify-start items-start shadow-md rounded-lg p-4">
      <div className="flex flex-row space-x-2">
        <div className="text-2xl">{title}</div>
        <div className="text-green-600">{icon}</div>
      </div>
      <div className="text-2xl font-bold">{count}</div>
      <p className="text-sm text-muted-foreground">{description}</p>
      <button
        type="button"
        onClick={onLinkClick}
        className="text-sm text-blue-600 underline cursor-pointer text-left p-0 bg-transparent border-none hover:text-blue-800 transition-colors"
      >
        {linkText}
      </button>
    </div>
  );
};

export default ContentCard;
